import { Flex } from "@/kit/antipad-ui/Flex"
import { Typography } from "@/kit/antipad-ui/Typography";
import styles from './styles.module.css';
import clsx from "clsx";

interface ToastComponentProps {
    message: string;
    type?: 'success' | 'error' | 'warning' | 'info';
}

export const ToastComponent: React.FC<ToastComponentProps> = ({ message, type = 'warning' }) => {
    return (
        <Flex justify="center" align="center" className={clsx(styles.component, type === 'error' && styles.error, type === 'success' && styles.success, type === 'warning' && styles.warning)}>
            <Typography>{message}</Typography>
        </Flex>
    )
}